export const zhCnLocale = {
  model: {
    post: '灵感'
  },
  post: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    desc: '描述',
    subtitle: '副标题',
    title: '标题',
    position: '优先级',
    image: '图片',
    tagList: '标签',
    hotspot: '热点',
    avatar: '头像',
    shareImage: '分享图片',
  }
}

export const enLocale = {
  model: {
    post: 'Experience'
  },
  post: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    desc: 'Desc',
    subtitle: 'Subtitle',
    title: 'Title',
    position: 'Position',
    image: 'Image',
    tagList: 'Tag',
    hotspot: 'Hotspot',
    avatar: 'Avatar',
    shareImage: 'Share image',
  }
}

